import { createSubscriber } from 'svelte/reactivity';
import { writable, type Writable } from 'svelte/store';

import type { ReactiveValue } from './reactive-value';

const writables = new WeakMap<ReactiveValue<unknown>, Writable<unknown>>();
export function useRV<T>(reactiveValue: ReactiveValue<T>): Writable<T> {
  const existing = writables.get(reactiveValue);
  if (existing) {
    return existing as Writable<T>;
  }
  const store = writable(reactiveValue.get(), () => {
    return reactiveValue.addEventListener('changed', (detail) => {
      store.set(detail.value);
    });
  });
  writables.set(reactiveValue, store);
  return store;
}

export function useRVSubscription<T>(reactiveValue: ReactiveValue<T>) {
  const subscribe = createSubscriber((update) => {
    return reactiveValue.addEventListener('changed', () => {
      update();
    });
  });
  return {
    get current() {
      subscribe();
      return reactiveValue.get();
    },
    set current(value: T) {
      reactiveValue.set(value);
    },
  };
}
